import { addGLEntity } from "../../../../../actions/Utilities/GLEntity";
import { useMutation } from "react-query";

const useAddGLEntity = () => {
  return useMutation(addGLEntity);
  // const queryClient = useQueryClient();

  // const { mutate } = useMutation(
  //   (GLEntityNewData) => addGLEntity(GLEntityNewData),
  //   {
  //     onSuccess: (res) => {
  //       if(res === "Duplicate"){
  //         toast.fire("Failed", "Duplicate record/s found.", "error");
  //       }
  //       else{
  //         queryClient.invalidateQueries(["GetGLEntitys"]);
  //         toast.fire("Success", "GL Entity Added Successfully", "success");
  //       }
  //     },
  //     onError: (error) => {
  //       toast.fire("Failed", "Failed to Add GL Entity", "error");
  //     },
  //   }
  // );

  // return mutate;
};
export default useAddGLEntity;
